import React from 'react';
import {Button, Checkbox, Icon, Input, InputNumber, Modal, Radio, Select, Table, Upload} from 'antd';
import {CLIENT_ID, SVC_AUDIT_TYPE, SVC_STATE} from '../../utils/constants';
import {FormattedMessage} from 'react-intl';

class MeetingService extends React.Component {
  constructor() {
    super();
    this.state = {
      priceInfo:null,
      showPriceModal: false,
      levelId: '',
      svcs: [],
      total: 0,
      currentLevel: {}
    };
  }

  componentWillMount() {
    const {meetingSvcData, svcData, meeting, intl} = this.props;
    let newState = {};
    newState.levelId = meetingSvcData.levelId;
    svcData.map(sd => {
      sd.svcs &&
      sd.svcs.map(s => {
        if (meetingSvcData.svcs.find(msd => msd.svcId == s.id)) {
          s.isOpen = true;
        } else {
          s.isOpen = false;
        }

        if (newState.levelId == null) {
          s.isOpen = true;
        }
      });
    });
    //如果没有保存过  则默认都选中
    if (false && meeting.hasSaveSvc == 0) {
      svcData.map(sd => {
        sd.svcs &&
        sd.svcs.map(s => {
          s.isOpen = true;
        });
      });
    }
    let level = svcData.find(s => s.id == meetingSvcData.levelId);
    if (level) {
      //如果已经保存过一次了

      //筛选掉已经是旧版本而且当前会议没有使用的
      let svcs = level.svcs.filter(s => {
        let flg = true;
        if (
          s.status == 1 &&
          !meetingSvcData.svcs.some(msd => msd.svcId == s.id)
        ) {
          flg = false;
        }
        return flg;
      });

      //筛选掉新的版本(已经有对应的旧的版本被使用的)
      let oldVersionSvcs = svcs.filter(s => s.status == 1);

      //通过oldVersionSvcs查找到对应的新的svc  并筛掉

      if (oldVersionSvcs && oldVersionSvcs.length > 0) {
        svcs = svcs.filter(s => {
          let flg = true;
          if (
            oldVersionSvcs.some(
              ss => s.isReplace == s.id || s.isReplace == ss.isReplace
            ) &&
            s.status == 0
          ) {
            flg = false;
          }
          return flg;
        });
      }

      svcs.map(s => {
        let totalPrice = s.price;
        if (false && meeting.hasSaveSvc == 0) {
          s.isOpen = true;
        }
        s.number = 1;
        meetingSvcData.svcs.map(msd => {
          if (msd.svcId == s.id) {
            s.number = msd.num;
            s.file = msd.file;
            s.fileName = msd.fileName;
            s.newDescribe = msd.remark;
            if (s.file) {
              s.fileList = [
                {
                  uid: `temp_${Math.random()}`,
                  name: s.fileName,
                  filePath: s.file
                }
              ];
            }
            totalPrice = parseInt(s.number) * s.price;
          }
        });
        s.total = totalPrice;
      });
      this.setState({
        currentLevel: level,
        levelId: meetingSvcData.levelId,
        svcs,
        total: meetingSvcData.total
      });
    }
  }

  render() {
    let {intl, dispatch, svcData, viewOnly, meeting} = this.props;
    const {svcAuditState} = meeting;
    console.log("...viewOnly",viewOnly);
    console.log("...svcAuditState",svcAuditState);
    viewOnly =
      viewOnly ||
      svcAuditState === SVC_STATE.audit ||
      svcAuditState === SVC_STATE.agree ||
      svcAuditState === SVC_STATE.noAudit;
    const {svcs} = this.state;
    let data = svcs;
    const columns = [
      {
        title: intl.formatMessage({
          id: 'meeting_service_apply_column_select'
        }),
        key: 'isOpen',
        width: '5%',
        render: record => {
          return (
            <Checkbox
              disabled={viewOnly}
              defaultChecked={true}
              checked={record.isOpen}
              onChange={e => {
                let newSvcs = this.state.svcs;
                let total = 0;
                newSvcs &&
                newSvcs.map(nsvc => {
                  if (nsvc.id == record.id) {
                    nsvc.isOpen = e.target.checked;
                    if (e.target.checked) {
                      total += (nsvc.number || 0) * parseFloat(nsvc.price);
                    }
                  } else {
                    if (nsvc.isOpen) {
                      total +=
                        parseFloat(nsvc.price) *
                        (nsvc.number ? nsvc.number : 0);
                    }
                  }
                });
                this.setState({svcs: newSvcs, total});
              }}
            />
          );
        }
      },
      {
        title: intl.formatMessage({
          id: 'meeting_service_apply_column_service_type'
        }),
        key: 'name',
        width: '10%',
        dataIndex: 'name'
      },
      {
        title: intl.formatMessage({id: 'meeting_service_apply_column_price'}),
        width: '10%',
        key: 'price',
        render: record => {
          if (record.unit) {
            return (
              <span>
                {record.price.toFixed(2)} / {record.unit}
              </span>
            );
          } else {
            return <span>{record.price.toFixed(2)}</span>;
          }
        }
      },
      {
        title: intl.formatMessage({
          id: 'meeting_service_apply_column_number'
        }),
        width: '10%',
        key: 'num',
        render: record => {
          if (record.countState == 0) {
            if (viewOnly) {
              return <span>{record.number || 1}</span>;
            }
            return (
              <div style={{display: 'flex', alignItems: 'center'}}>
                <span
                  style={{
                    marginRight: '5px',
                    color: 'red',
                    verticalAlign: 'middle',
                  }}
                >
                  *
                </span>
                <InputNumber
                  min={1}
                  value={record.number || ''}
                  precision={0}
                  onChange={value => {
                    if (isNaN(value)) {
                      value = parseFloat(0);
                    }
                    let newSvcs = this.state.svcs;
                    let total = 0;
                    newSvcs &&
                    newSvcs.map(nsvc => {
                      if (nsvc.id == record.id) {
                        nsvc.number = value;
                        nsvc.total = value * parseFloat(nsvc.price);
                        if (nsvc.isOpen) {
                          total += value * parseFloat(nsvc.price);
                        }
                      } else {
                        if (nsvc.isOpen) {
                          total +=
                            parseFloat(nsvc.price) *
                            (nsvc.number ? nsvc.number : 0);
                        }
                      }
                    });
                    this.setState({svcs: newSvcs, total: total});
                  }}
                />
              </div>
            );
          } else {
            return <span>{record.number || 1}</span>;
          }
        }
      },
      {
        title: intl.formatMessage({id: 'meeting_service_apply_column_total'}),
        key: 'total',
        width: '10%',
        render: record => {
          let total = parseFloat(record.total);
          return <span>{total.toFixed(2)}</span>;
        }
      },
      {
        title: intl.formatMessage({
          id: 'meeting_service_apply_column_remark'
        }),
        width: '23%',
        key: 'describe',
        render: record => {
          if (record.describeState == 1) {
            return <span>{record.describe}</span>;
          } else {
            return (
              <div
                className="remark"
                style={{display: 'flex', alignItems: 'center'}}
              >
                <span
                  style={{
                    marginRight: '5px',
                    color: 'red',
                    verticalAlign: 'middle',
                  }}
                >
                  *
                </span>
                <Input
                  placeholder={record.describe}
                  disabled={viewOnly}
                  value={record.newDescribe}
                  onChange={e => {
                    let newSvcs = this.state.svcs;
                    newSvcs &&
                    newSvcs.map(nsvc => {
                      if (nsvc.id == record.id) {
                        nsvc.newDescribe = e.target.value;
                      }
                    });
                    this.setState({svcs: newSvcs});
                  }}
                />
              </div>
            );
          }
        }
      },
      {
        title: intl.formatMessage({id: 'meeting_service_apply_column_file'}),
        width: '22%',
        key: 'file',
        render: record => {
          if (record.uploadState !== 0) {
            return null;
          }
          return (
            <Upload
              name="fileUpload"
              showUploadList={viewOnly ? {showRemoveIcon: false} : true}
              onPreview={file => {
                let url = '';
                if (file.filePath) {
                  url = file.filePath;
                } else {
                  if (file.response.result === 0) {
                    url = file.response.list[0].fileUrl;
                  }
                }
                window.open(url);
              }}
              action={`/storage/file/savefile?lang=zh_CN&token=${sessionStorage.getItem(
                'token'
              )}&fromType=${CLIENT_ID}`}
              onChange={
                viewOnly
                  ? null
                  : info => {
                    let fileList = info.fileList;
                    let file = info.file;
                    if (fileList.length > 0) {
                      fileList = [fileList[fileList.length - 1]];
                    }
                    if (file.size > 10 * 1024 * 1024) {
                      return false;
                    }
                    svcs.map(item => {
                      if (item.id == record.id) {
                        item.fileList = fileList;
                        if (file.status == 'done' && file.response) {
                          item.file = file.response.list[0].fileUrl;
                          item.fileName = file.name;
                        } else {
                          item.file = '';
                          item.fileName = '';
                        }
                      }
                    });
                    this.setState({svcs});
                  }
              }
              fileList={record.fileList || []}
              beforeUpload={file => {
                if (file.size > 10 * 1024 * 1024) {
                  Modal.error({content: '附件最大不能超过10M!'});
                  return false;
                }
              }}
            >
              {viewOnly ? null : (
                <div title="文件大小不能超过10Mb" style={{cursor: 'pointer'}}>
                  <Button>
                    <Icon type="upload"/> <FormattedMessage id='re_upload'/>
                  </Button>
                </div>
              )}
            </Upload>
          );
        }
      }
    ];

    const statusMsg = this.getAuditStatusMsg();
    const warningMsg = this.getAuditWarningMsg();
    return (
      <div className="meeting_service">
        <div className="service_table">
          <div className="button_div">
            <Select
              dropdownMatchSelectWidth={false}
              dropdownStyle={{width: '500px'}}
              disabled={viewOnly}
              style={{width: '200px'}}
              value={this.state.levelId + ''}
              onChange={lid => {
                if (lid == '') {
                  this.setState({
                    levelId: '',
                    currentLevel: {},
                    svcs: [],
                    total: 0
                  });
                } else {
                  let sData = svcData.find(sd => sd.id == lid);
                  let svcs = [];
                  if (sData) {
                    //筛选掉已经是旧版本而且当前会议没有使用的
                    svcs = sData.svcs.filter(s => {
                      let flg = true;
                      if (
                        s.status == 1 &&
                        !this.props.meetingSvcData.svcs.some(
                          msd => msd.svcId == s.id
                        )
                      ) {
                        flg = false;
                      }
                      return flg;
                    });

                    //筛选掉新的版本(已经有对应的旧的版本被使用的)
                    let oldVersionSvcs = svcs.filter(s => s.status == 1);
                    //通过oldVersionSvcs查找到对应的新的svc  并筛掉
                    if (oldVersionSvcs && oldVersionSvcs.length > 0) {
                      svcs = svcs.filter(s => {
                        let flg = true;
                        if (
                          oldVersionSvcs.some(
                            ss =>
                              s.isReplace == s.id || s.isReplace == ss.isReplace
                          ) &&
                          s.status == 0
                        ) {
                          flg = false;
                        }
                        return flg;
                      });
                    }
                  }
                  let total = 0;
                  svcs.map(item => {
                    item.isOpen = false;
                    if (false && this.props.meeting.hasSaveSvc == 0) {
                      item.isOpen = true;
                    }
                    item.newDescribe = '';
                    if (item.countState === 0) {
                      //可计量
                      //item.number = 0;
                      //item.total = 0;
                      item.number = 1;
                      item.total = parseFloat(item.price);
                    } else {
                      item.number = 1;
                      item.total = parseFloat(item.price);
                    }
                    if (item.isOpen) {
                      total += parseFloat(item.total);
                    }
                  });
                  this.setState({
                    levelId: lid,
                    currentLevel: sData,
                    svcs: svcs,
                    total
                  });
                }
              }}
              placeholder={'请选择服务级别'}
            >
              <Select.Option value="">
                <div className="drop_down_div">
                  <Radio checked={this.state.levelId == 0}/>
                  <div style={{color: 'gray', marginLeft: '10px'}}>
                    无<br/>
                    {``}
                  </div>
                </div>
              </Select.Option>
              {svcData &&
              svcData.map(sd => {
                return (
                  <Select.Option key={`${sd.id}`} value={`${sd.id}`}>
                    <div className="drop_down_div">
                      <Radio checked={this.state.levelId == sd.id}/>
                      {sd.remark ? (
                        <div style={{marginLeft: '10px'}}>
                          <div style={{color: 'black'}}>{`${sd.name}`}</div>
                          <div style={{color: 'gray', marginTop: '10px'}}>
                            {sd.remark}
                          </div>
                        </div>
                      ) : (
                        <div style={{marginLeft: '10px'}}>
                          {`${sd.name}`}
                        </div>
                      )}
                    </div>
                    <div className="for_selected" style={{color: "red'"}}>
                      {`${sd.name}`}
                    </div>
                  </Select.Option>
                );
              })}
            </Select>
            {statusMsg ? (
              <span className="sl-audit-msg status-show">
                {warningMsg}
                {statusMsg}
              </span>
            ) : (
              <span className="sl-audit-msg warning">{warningMsg}</span>
            )}
            <div className="right_btn_div">
              <span className="total_price_span">
                <span>
                  <FormattedMessage id="meeting_service_apply_label_total"/>:
                </span>
                <span className="price">{this.state.total.toFixed(2)}</span>
                <span>
                  <FormattedMessage id="meeting_service_apply_label_yuan"/>
                </span>
              </span>
              <div className="button_div">
                {viewOnly ? null : (
                  <div
                    className="meeting_button"
                    onClick={() => {
                      const _this = this;
                      if (meeting && meeting.type != 0) {
                        Modal.confirm({
                          content: '是否将该会议服务申请同步到其余未开始的会议?',
                          okText: '是',
                          onOk: function () {
                            this.saveMeetingService({skipPrice:0,type:1});
                          },
                          cancelText: '否',
                          onCancel: function () {
                            this.saveMeetingService({skipPrice:0,type:0});
                          }
                        });
                      } else {
                        this.saveMeetingService({skipPrice:0,type:0});
                      }
                    }}
                  >
                    <FormattedMessage id="meeting_service_apply_btn"/>
                  </div>
                )}
              </div>
            </div>
          </div>
          {this.state.currentLevel.remark ? (
            <div className="remark_div">
              <Icon type="info-circle" style={{color: '#207EFB'}}/>
              &nbsp;&nbsp;
              {this.state.currentLevel.remark}
            </div>
          ) : null}
          <Table
            rowKey={record => record.id}
            dataSource={data}
            columns={columns}
            pagination={false}
          />
        </div>
        <Modal
          title={<div className="meeting_fee_title">{intl.formatMessage({id: 'meeting_fee_notice'})}</div>}
          maskClosable={false}
          visible={this.state.showPriceModal}
          onOk={() => {
            this.saveMeetingService({skipPrice:1,type:0});
          }}
          onCancel={() => {
            this.setState({showPriceModal: false})
          }}
          okText={intl.formatMessage({id: 'continue_apply'})}
          cancelText={intl.formatMessage({id: 'cancel_apply'})}
          wrapClassName="meeting_fee_wrap"
          width={450}
        >
          {this.getFeeDiv()}
        </Modal>
      </div>
    );
  }

  saveMeetingService = ({skipPrice = 0,type = 0}) => {
    const {intl,dispatch,meeting} = this.props;
    const promise = new Promise((resolve, reject) => {
      dispatch({
        type: 'meetingInfo/saveMeetingService',
        payload: {
          svcs: this.state.svcs,
          levelId: this.state.levelId,
          type,
          skipPrice
        },
        resolve,
        reject
      });
    });
    promise.then(() => {
      this.setState({"showPriceModal":false});
      Modal.success({
        content: intl.formatMessage({id: 'index_save_success'}),
        okText: intl.formatMessage({id: 'modal_manage_btn_ok'})
      });
      dispatch({
        type: 'meetingInfo/getMeetingInfo',
        payload: {meetingId: meeting.id}
      });
      dispatch({type: 'meetingInfo/getMeetingSvc', payload: {meetingId: meeting.id}})
    }, ({data, msg}) => {
      if ("noticePrice" == msg) {
        this.setState({showPriceModal: true,priceInfo:data});
      }else{
        this.setState({"showPriceModal":false});
      }
    })
  };

  getFeeDiv = () => {
    const {intl,meetingPolicy={billingSwitch:1}} = this.props;
    const {priceInfo} = this.state;
    if(priceInfo == null) {
      return null;
    }
    const {roomPrice = 0,svcPrice = 0, total =0} = priceInfo;
    return <div className="fee_div">
      {meetingPolicy.billingSwitch === 1 &&  <div className="fee_row">
        <div>{intl.formatMessage({id: 'room_fee_total'})}</div>
        <div className="right">￥{parseFloat(roomPrice).toFixed(2)}</div>
      </div>}
      <div className="fee_row">
        <div>{intl.formatMessage({id: 'meeting_svc_fee_total'})}</div>
        <div className="right">￥{parseFloat(svcPrice).toFixed(2)}</div>
      </div>
      <div className="fee_row">
        <div>{intl.formatMessage({id: 'meeting_fee_total'})}</div>
        <div style={{color: "red"}} className="right">￥{parseFloat(total).toFixed(2)}</div>
      </div>
    </div>;
  };

  getAuditStatusMsg = () => {
    const {meeting = {}, intl} = this.props;
    const {svcAuditState} = meeting;
    let statusMsg = '';
    switch (svcAuditState) {
      case SVC_STATE.audit:
        statusMsg =
          <span>{intl.formatMessage({id: 'meeting_service_current_status'}) + intl.formatMessage({id: 're_auditing'})}</span>;
        break;
      case SVC_STATE.reject:
        statusMsg =
          <span>{intl.formatMessage({id: 'meeting_service_current_status'}) + intl.formatMessage({id: 're_audit_failed'})}</span>;
        break;
      case SVC_STATE.agree:
        statusMsg =
          <span>{intl.formatMessage({id: 'meeting_service_current_status'}) + intl.formatMessage({id: 're_audit_success'})}</span>;
        break;
    }
    return statusMsg;
  };

  getAuditWarningMsg = () => {
    if (!this.state.currentLevel.id) return '';
    let warningMsg = '';
    const {auditType = SVC_AUDIT_TYPE.no, name} = this.state.currentLevel;
    switch (auditType) {
      case SVC_AUDIT_TYPE.yes:
        warningMsg = (
          <span><FormattedMessage id='meeting_services_info_value9'/></span>
        );
        break;
    }
    return warningMsg;
  };
}

export default MeetingService;



// WEBPACK FOOTER //
// ./src/components/meetingList/MeetingService.js